// istanbul ignore file: doesn't hold any logic
import { RichText } from "./RichText";
export default RichText;
